import React from "react";
import { formatINR } from "../../Pages/accounts/accountUser";

export default function EntryPreview({ lines }) {
  const debits = (lines || []).filter((line) => Number(line.debit) > 0);
  const credits = (lines || []).filter((line) => Number(line.credit) > 0);
  const totalDebit = debits.reduce((sum, line) => sum + Number(line.debit), 0);
  const totalCredit = credits.reduce((sum, line) => sum + Number(line.credit), 0);
  return (
    <div className="accounts-preview-table">
      <div className="accounts-preview-row head"><span>Particulars</span><span /><span>Debit</span><span>Credit</span></div>
      {debits.map((line, index) => (
        <div className="accounts-preview-row" key={`d${index}`}>
          <span>{line.ledgerName || "—"} A/c</span><span>Dr</span><span>{formatINR(line.debit)}</span><span />
        </div>
      ))}
      {credits.map((line, index) => (
        <div className="accounts-preview-row" key={`c${index}`}>
          <span className="indent">To {line.ledgerName || "—"} A/c</span><span /><span /><span>{formatINR(line.credit)}</span>
        </div>
      ))}
      <div className="accounts-preview-row total"><span>Total</span><span /><span>{formatINR(totalDebit)}</span><span>{formatINR(totalCredit)}</span></div>
    </div>
  );
}
